'use client';

import { forwardRef } from 'react';
import type { FlexProps as MantineFlexProps } from '@mantine/core';
import { Flex as MantineFlex } from '@mantine/core';

type FlexProps = MantineFlexProps;

export const Flex = forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  return <MantineFlex ref={ref} {...props} />;
});

Flex.displayName = 'Flex';
